import { createContext, useContext, type ReactNode } from 'react';
import { useSoftphone } from '@/hooks/useSoftphone';
import { useAutoAgentStatus } from '@/hooks/useAutoAgentStatus';

type SoftphoneContextValue = ReturnType<typeof useSoftphone>;

const SoftphoneContext = createContext<SoftphoneContextValue | null>(null);

export function SoftphoneProvider({ children }: { children: ReactNode }) {
  const softphone = useSoftphone();
  useAutoAgentStatus();
  return (
    <SoftphoneContext.Provider value={softphone}>
      {children}
    </SoftphoneContext.Provider>
  );
}

export function useSoftphoneContext(): SoftphoneContextValue {
  const ctx = useContext(SoftphoneContext);
  if (!ctx) {
    throw new Error('useSoftphoneContext must be used within SoftphoneProvider');
  }
  return ctx;
}

/** Safe version that returns null if no provider is present */
export function useSoftphoneContextSafe(): SoftphoneContextValue | null {
  return useContext(SoftphoneContext);
}
